import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import styles from "./StoreLocatorProductAttributeValues.module.scss";
const VALUE_ITEMS_GAP = 4;
export const StoreLocatorProductAttributeValues = ({ values, titleRef, containerRef, }) => {
    const itemRefs = useRef([]);
    const [visibleCount, setVisibleCount] = useState(values.length);
    useEffect(() => {
        const update = () => {
            const [fullWidth, titleWidth] = [containerRef, titleRef].map((ref) => ref.current?.offsetWidth ?? 0);
            const availableWidth = fullWidth - titleWidth;
            const { count } = values.reduce((acc, _, index) => {
                const el = itemRefs.current[index];
                if (!el)
                    return acc;
                const nextTotal = acc.total + el.offsetWidth + VALUE_ITEMS_GAP;
                if (nextTotal > availableWidth)
                    return acc;
                return {
                    total: nextTotal,
                    count: acc.count + 1,
                };
            }, { total: 0, count: 0 });
            setVisibleCount(count);
        };
        update();
        const observer = new ResizeObserver(update);
        if (containerRef.current)
            observer.observe(containerRef.current);
        window.addEventListener("resize", update);
        return () => {
            observer.disconnect();
            window.removeEventListener("resize", update);
        };
    }, [values]);
    const displayed = values.slice(0, visibleCount);
    const hiddenCount = values.length - displayed.length;
    return (_jsxs("div", { className: styles.productAttributeValues, "data-testid": "storeLocatorAttributeValues", children: [_jsx("div", { className: styles.productAttributeValuesList, children: displayed.map(({ value }, idx) => (_jsxs("span", { className: styles.productAttributesAdditional, ref: (el) => (itemRefs.current[idx] = el), children: [value, idx < displayed.length - 1 && " · "] }, value.toString()))) }), hiddenCount > 0 && (_jsxs("span", { className: styles.productAttributeValuesCount, "data-testid": "attributeValuesCount", children: ["+", hiddenCount] }))] }));
};
//# sourceMappingURL=StoreLocatorProductAttributeValues.js.map